<template>
    <div class="review">
        <div class="query-item">
            <div class="search-l">
                <div v-if="!store.roles.includes('carEnterprise')" style="margin-right: 30px;">
                    测试主体
                    <a-input class="inp ml24" placeholder="请输入" v-model:value="query.deptName"></a-input>
                </div>
                <div>
                    测试牌照
                    <a-input class="inp ml24" placeholder="请输入" v-model:value="query.testCarNum"></a-input>
                </div>

                <div class="ml30">
                    日期
                    <a-range-picker class="ml24" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" @change="timeChange"
                        v-model:value="time" />
                </div>
                <a-button class="ml24" @click="search" type="primary" ghost>查询</a-button>
                <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
                <div></div>
            </div>
            <div v-if="store.roles.includes('carEnterprise')">
                <a-button class="ml24" @click="add" type="primary">上传报告</a-button>
            </div>
        </div>
        <a-table :columns="store.roles.includes('carEnterprise') ? columns : columns2" :row-key="(record) => record.id"
            :data-source="dataSource" class="mt23" size="middle" :pagination="pagination"
            :scroll="{ x: 1500, y: 'auto' }" v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
            <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'createTime'">
                    {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
                </template>
                <template v-if="column.key === 'action'">
                    <span>
                        <a class="mr10" @click="detail(record)">详情</a>
                        <a-popconfirm title="确定删除?" ok-text="确定" cancel-text="取消" @confirm="del(record)">
                            <a class="ml10">删除</a>
                        </a-popconfirm>
                    </span>
                </template>
            </template>
        </a-table>

        <detailModal :modalTitle="title" :modalWidth="'702px'" :isDetailStatus="title == '上传报告' ? true : false"
            ref="modalRef" @saveEvent="saveEvent" @cancelEvent="cancelEvent">
            <div class="detail add" v-if="title == '上传报告'">
                <div class="cars">
                    <div class="tit">选择车辆</div>
                    <div class="cont">
                        <!-- <a-select v-model:value="value" mode="multiple" style="width: 100%" placeholder="Select Item..."
                            :max-tag-count="2" :options="options">
                            <template #maxTagPlaceholder="omittedValues">
                                <span style="color: red">+ {{ omittedValues.length }} ...</span>
                            </template>
                        </a-select> -->

                        <mySelectAll style="width: 100%" :myAjax="getCars" :query="AjaxData" :newDataStatus="true"
                            :oldValue="mySelectAllData" ref="carRef" />
                    </div>

                </div>
                <div class="filelist">
                    <div class="file_text">
                        阶段性报告
                    </div>
                    <div class="into">下载模板，根据模板提示完善内容</div>
                    <a :href="fileUrl" target="_blank" class="update_btn">
                        <a style="color: #636D7B;"><i
                                class="iconfont icon-dianjixiazaiicon update_icon mr5"></i>点击下载</a>
                    </a>
                </div>
                <div class="mt16">
                    <upload :pathName="'car'" ref="uploadRef" accept=".xls,.docx,.doc" @uploadFinished="uploadFinished">
                    </upload>
                </div>
                <!-- <div class="mt16 botmBtn">
                    <a-button type="primary" ghost class="mr10"  @click="cancel">取消</a-button>
                    <a-button type="primary" class="ml10" @click="confirm">确定</a-button>
                </div> -->
            </div>
            <div class="detail" v-if="title == '报告详情'">
                <div class="cars">
                    <div class="tit">车辆</div>
                    <div class="cont">{{ form.testCarNums }}</div>

                </div>
                <div class="filelist">
                    <div class="item">
                        <FileTextOutlined />阶段性报告.xls
                    </div>
                    <div class="btns">
                        <a class="upload_a" :href="form.reportFileUrl" target="_blank">下载</a>
                    </div>
                </div>

            </div>
        </detailModal>


    </div>
</template>
<script setup name="task">
import { ref, reactive, toRefs, onBeforeMount, onMounted, nextTick } from 'vue'
import { useRouter } from "vue-router";
import { FileTextOutlined } from '@ant-design/icons-vue'
import detailModal from '@/components/modal/index.vue'
import upload from '@/components/uploadProgress/index.vue'
import mySelectAll from '@/components/selectAll/index.vue'
import { selectPageList, getTemplateFileUrl, insertOne, detailData, deleteBatch } from '@/api/report/phased.js'
import { getCars } from "@/api/car/car.js";
import useUserStore from '@/store/modules/user'
import { message } from 'ant-design-vue';


const router = useRouter();
const store = useUserStore();

const title = ref('')
const columns = [
    {
        title: "序号",
        dataIndex: "ranking",
        key: "ranking",
        width: 100,
        fixed: 'left',
    },
    {
        title: "测试牌照",
        key: "testCarNums",
        dataIndex: "testCarNums",
    },
    {
        title: "上传时间",
        key: "uploadTimeStr",
        dataIndex: "uploadTimeStr",
        width: 160,
    },
    {
        title: "操作",
        key: "action",
        fixed: 'right',
        width: 150,
    },
];

const columns2 = [
    {
        title: "序号",
        dataIndex: "ranking",
        key: "ranking",
        width: 100,
        fixed: 'left',
    },
    {
        title: "测试主体",
        dataIndex: "deptName",
        key: "deptName",
        width: 200,
    },
    {
        title: "测试牌照",
        key: "testCarNums",
        dataIndex: "testCarNums",
    },
    {
        title: "上传时间",
        key: "uploadTimeStr",
        dataIndex: "uploadTimeStr",
        width: 160,
    },
    {
        title: "操作",
        key: "action",
        fixed: 'right',
        width: 150,
    },
];

const time = ref([])

let query = reactive({
    testCarNum: "",
    startDateStr: "",
    endDateStr: "",
    deptName: ""
});

const AjaxData = ref({
    pageIndex: null, pageSize: null,
    conditionMap: {
        deptName: "", frameNum: "", testCarNum: ""
        , deptIdStr: store.deptId
    }
})


const timeChange = value => {
    console.log(value);
    query.startDateStr = value[0]
    query.endDateStr = value[1]
}

const search = () => {
    pagination.current = 1;
    getData();
};

const reset = () => {
    query.testCarNum = "";
    query.startDateStr = ""
    query.endDateStr = ""
    query.deptName = ""
    time.value = []
    pagination.current = 1;
    getData();
};

let dataSource = ref([]);

const pagination = reactive({
    total: 0,
    size: "middle",
    defaultPageSize: 10,
    current: 1,
    pageSize: 20, //每页中显示10条数据
    showSizeChanger: true,
    showQuickJumper: false,
    pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
    showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
    onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
    onChange: pageChange, //点击页码事件
    showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
    pagination.current = page;

    // 获取表格数据
    getData();
}

function pageSizeChange(current, size) {
    console.log(size);
    pagination.pageSize = size;

    // 获取表格数据
    getData();
}


const getData = () => {
    const data = {
        pageIndex: pagination.current,
        pageSize: pagination.pageSize,
        conditionMap: { ...query },
    };
    selectPageList(data).then((res) => {

        dataSource.value = res.data.records || [];
        pagination.total = res.data.total;
    });
};

const modalRef = ref()
const del = (record) => {
    console.log(record)
    deleteBatch({
        deleteIds: [
            record.id
        ]
    }).then(res => {
        if (res.code === 200) {
            message.success('删除报告成功')
            getData()
        }
    })

}
const uploadRef = ref()
// uploadRef.value.clearFileList()
let uploadFileUrl = ref();
const uploadFinished = (res) => {
    console.log('上传成功', res);
    uploadFileUrl.value = res
}

const mySelectAllData = ref([]);

// const options = ref([]);
// for (let i = 10; i < 36; i++) {
//     const value = i.toString(36) + i;
//     options.value.push({
//         label: `Long Label: ${value}`,
//         value,
//     });
// }

const carRef = ref()

const fileUrl = ref('')
// 获取模板
const getTemplateFileUrlData = () => {
    getTemplateFileUrl().then(res => {
        console.log(res);
        if (res.code === 200) {
            fileUrl.value = res.data
        }
    })
}


const add = () => {
    title.value = "上传报告";
    modalRef.value.showModal()
}

const confirm = () => {

    modalRef.value.showModal()
}

const form = ref({})
const detail = (record) => {
    console.log(record);
    title.value = "报告详情";
    modalRef.value.showModal()
    detailData({ id: record.id }).then(res => {
        console.log(res);
        if (res.code === 200) {
            form.value = res.data
        }
    })
};

function saveEvent(a) {
    console.log('保存')
    console.log(carRef.value.valueList);
    let carIds = carRef.value.valueList
    let data = {
        reportFileUrl: uploadFileUrl.value,
        carIds
    }
    insertOne(data).then(res => {
        if (res.code === 200) {
            message.success('上传报告成功')
            getData()
            uploadRef.value.reset();
            carRef.value.valueList = [];
        }
    })

}

function cancelEvent() {
    console.log('取消');
    console.log(uploadRef.value);
    uploadRef.value ? uploadRef.value.reset() : null;
    carRef.value ? carRef.value.valueList = [] : null;
}

onMounted(async () => {
    getData();
    getTemplateFileUrlData()
});


</script>
<style lang="less" scoped>
.review {
    padding: 13px 20px 20px 20px;
    height: calc(100vh - 70px - 57px);
    background-color: #ffffff;
}

.inp {
    width: 13.5vw;
}

.query-item {
    display: flex;
    justify-content: space-between;

    .search-l {
        display: flex;
    }

    .search-r {
        display: flex;
    }
}

.modal_item {
    padding: 0 26px 106px 23px;
    background: #F6F8FA;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;

    .file_text {
        padding-top: 19px;
        border-bottom: 1px solid #D4E0F0;

        .fil_it {
            display: flex;
            align-items: center;
            padding-left: 49px;
            padding-bottom: 19px;

            .file_tit {
                font-size: 14px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                color: #6C7683;
            }

            .file_ic {
                font-size: 14px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                color: #1D2129;
            }
        }

        .file_icon {
            color: rgba(24, 111, 242, 1);
        }
    }


}

.mr10 {
    margin-left: 10px;
}

a {
    color: #1E8EF2;
}

.radio_class {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: rgba(29, 33, 41, 1);
}

.area_class {
    // display: flex;
}

.area_width {
    // width: 420px;
    // margin-left: 26px;
    margin-top: 22px;
}

.mt22 {
    margin-top: 22px;
}

.mt32 {
    margin-top: 32px;
}

.mb85 {
    margin-bottom: 85px;
}

.mb26 {
    margin-bottom: 26px;
}

.ml26 {
    margin-left: 26px;
}

.pl30 {
    padding-left: 30px;
}

.pl43 {
    padding-left: 43px;
}

.pl15 {
    padding-left: 15px;
}

.pl55 {
    padding-left: 55px;
}

.pl89 {
    padding-left: 89px;
}

.pl91 {
    padding-left: 91px;
}

.detail {
    padding: 75px 80px 30px 80px;

    .cars {
        border: 1px solid #E1E7EF;
        margin-bottom: 24px;

        .tit {
            background: #F6F8FA;
            padding: 11px 33px;
            font-weight: 600;
            color: #1D2129;
        }

        .cont {
            padding: 15px 28px;
        }
    }

    .filelist {
        border: 1px solid #E1E7EF;
        padding: 20px 0;
        text-align: center;

        .item {
            color: #636D7B;
            font-size: 14px;

            .anticon {
                color: #186FF2;
                margin-right: 13px;
            }
        }

        .btns {
            margin-top: 19px;
        }
    }

    .file_text {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #1D2129;
    }

    .into {
        font-size: 14px;
        color: #636D7B;
        margin: 16px 0;
    }

    .update_btn {
        cursor: pointer;
        display: inline-block;
        padding: 2px 0;
        width: 100px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #636D7B;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #636D7B;
        text-align: center;
    }
}

.add {
    .cars {
        display: flex;
        align-items: center;
        border: none;

        .tit {
            background-color: transparent;
            width: 85px;
            padding: 11px 0;
        }

        .cont {
            padding: 0;
            width: 100%;
        }

    }

    .filelist {
        text-align: center;
        background: #F6F8FA;
    }
}

.update_btn {
    cursor: pointer;
    padding: 3px 0;
    width: 100px;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #636D7B;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #636D7B;
    text-align: center;
    margin: 20px auto 0;
}

.upload_a {
    display: inline-block;
    width: 60px;
    height: 32px;
    background: #1E8EF2;
    color: #fff;
    box-shadow: 0 2px 0 rgba(8, 96, 137, 0.17);
    padding: 4px 15px;
    border-radius: 4px;
    border: 1px solid transparent;
    transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1)
}

/deep/.ant-tabs .ant-tabs-tab {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    margin: 0 0 0 70px;
    color: rgba(29, 33, 41, 0.7);
}

/deep/.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #1D2129;
}


/deep/.ant-tabs-nav {
    margin-bottom: 24px;
}

/deep/.ant-tabs-top>.ant-tabs-nav .ant-tabs-ink-bar {
    height: 3px;
    // background: rgba(30, 142, 242, 1);
}

/deep/.ant-upload-wrapper .ant-upload-list {
    width: 130px;
}
</style>
